import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class GridStateService {
  private _maxPrimaryKeyValue = new BehaviorSubject<number | null>(null);
  maxPrimaryKeyValue$ = this._maxPrimaryKeyValue.asObservable();

  setMaxPrimaryKeyValue(val: number): void {
    this._maxPrimaryKeyValue.next(val);
  }

  getMaxPrimaryKeyValue(): number | null {
    return this._maxPrimaryKeyValue.getValue();
  }

  clear(): void {
    this._maxPrimaryKeyValue.next(null);
  }
}



// WEBPACK FOOTER //
// ./app/insa-services/gridState.service.ts